import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7btl61xote: FaireBrandEntity = {
  token: "b_7btl61xote",
  type: "brand",
  name: "homeolab International Inc",
  avatarUrl:
    "https://cdn.faire.com/fastly/52b97c44ddcc4169d08013f07810aa066b809691af2ba60fd7838f6c24a20949.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/2466c75b3cbb53da660252111d96ed2973940864fc0d193e981fcf3cd92da9ec.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/52b97c44ddcc4169d08013f07810aa066b809691af2ba60fd7838f6c24a20949.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2466c75b3cbb53da660252111d96ed2973940864fc0d193e981fcf3cd92da9ec.jpeg",
  location: "Champlain, NY, USA",
  minimumOrderDollars: 277,
  rating: 5,
  reviewCount: 2,
  isInsider: false,
  description:
    "Kids Relief® has been trusted by mothers across Canada since 1993 and can now be found in a growing number of stores throughout the United States. Because Kids Relief® products are 100% natural, they provide relief without the worry of harmful side effects. Homeopathic medicines are considered among the safest medicinal option in the world. There is no risk of overdose or potential negative interaction with other medicines. With Kids Relief® your child will receive fast-acting, effective relief without the addition of alcohol, dyes and sugars. Also, you will have no problems getting your kids to take these easy-to-administer, great-tasting formulas.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:18.274Z",
    importedBy: "entity-db-cli",
  },
};
